import ReactComponent from '../app/ReactComponent'

import {AP_AGREEMEMT_TYPE_ID} from '../helpers/misc'

import {Col, Layout, Row, Spin, Image, Button, Space} from 'antd'
import {Link} from 'react-router-dom'
import React, {createRef} from 'react'
import AvatarWoman from '../image/dashboard/avatar_zena.svg'
import AvatarMan from '../image/dashboard/avatar_muz.svg'
import HealthConditionSVG from '../image/dashboard/zdavotni_stav.svg'
import ProfileSVG from '../image/dashboard/muj_profil.svg'
import AmberAccountSVG from '../image/dashboard/amber_konto.svg'
import CollectionAppointmentSVG from '../image/dashboard/rezervace_odberu.svg'
import MyOrdersSVG from '../image/moje_objednavky.svg'
import {NavTileItem} from '../components/layout/NavTileItem'
import Query from '../app/Query'
import {formatZIP} from '../helpers/utils'
import App from '../app/App'
import {LoyaltyStatusTag} from '../components/loyalty-status/LoyaltyStatusTag'
import {getLoyaltyStatus} from '../services/properties'

export class ProfilePage extends ReactComponent {
  accountFormRef = createRef()

  state = {
    loading_page: false,
    constants: {
      AP_AGREEMEMT_TYPE_ID
    },
    account: {},
    status_name: '',
    loyalty_status: null,
    bookings: [],
    arrived_alert: false,
    agreement_label: 'Souhlas se zpracováním osobních údajů',
    agreement_text: false,
    agreement_marketing_communication: null,
    homeStore: null,
    mostVisitedStore: null,
    latestVisitedStore: null,
    loading_center_data: false,
    loading_account: false,
    is_allowed_to_show_registration_survey: false,
    is_allowed_to_show_obnoveni_kvalifikace_survey: false
  }

  async componentDidMount() {

    this.scrollToTop()

    this.pushPageAnalytics('Můj profil - Moje Amber')

    void this.updateState({loading_page: true, loading_center_data: true, loading_account: true})

    void this.getData()

  }

  async getData() {
    const account = await this.$app.$store('account').getPersonalInfo()

    const status_name = await this.$app.$store('account').getStatus()

    const loyalty_status = await getLoyaltyStatus(await this.$app.$store('account').getProperties())

    const homeStore = await this.$app.$store('account').getStoreById(account.store_id)

    const {segment_records = []} = await this.$api({
      action: 'carecloud_user_api',
      route: 'segment-records'
    })

    void this.getMyCenterData()

    await this.updateState({
      loading_page: false,
      account,
      status_name,
      loyalty_status,
      homeStore,
      loading_account: false
    })

    void this.updateState({
      is_allowed_to_show_registration_survey: await this.$app.$store('account').isAllowedToShowRegistrationSurvey(segment_records),
      is_allowed_to_show_obnoveni_kvalifikace_survey: await this.$app.$store('account').isAllowedToShowObnoveniKvalifikaceSurvey(segment_records)
    })

  }

  async getMyCenterData() {
    let {mostVisitedStore, latestVisitedStore} = await this.$app.$store('account').getLatestAndMostVisitedStore()

    void this.updateState({
      mostVisitedStore,
      latestVisitedStore,
      loading_center_data: false
    })

  }

  handleDigitalSurveyTaleClick(e) {
    e.preventDefault()
    if(this.state.account.gender === '2')
      App.$toast('Není třeba, aby jste nyní vyplňovala dotazník.')
    else
      App.$toast('Není třeba, aby jste nyní vyplňoval dotazník.')

    return false
  }

  render() {
    const {mostVisitedStore, latestVisitedStore, account, homeStore} = this.state

    return (
      <Layout tagName="main" className="page-with-title">

        <h1>Můj profil</h1>

        <Row align="center" className="margin-auto" style={{padding: '0 1em'}}>
          <Col xs={24}>
            <Spin spinning={this.state.loading_page} size="large">

              <Row justify="center" className="margin-auto account-row" gutter={[20, 0]}>

                <Col xs={16} sm={18} md={18} className="left-col">
                  <Row>

                    <Col xs={24}>
                      <Space direction="horizontal" align="end" className="mb-1" wrap>
                        <Spin spinning={this.state.loading_account}>
                          {account.first_name && account.last_name && <>
                            <h3>
                              {account.first_name + ' ' + account.last_name}
                            </h3>
                          </>}
                        </Spin>
                        <LoyaltyStatusTag status={this.state.loyalty_status} linkTo="/rewards"/>
                      </Space>
                    </Col>

                    <Col xs={24}>
                      <div className="status">{!this.state.loading_account && `Status: ${this.state.status_name}`}</div>
                    </Col>

                  </Row>

                </Col>

                <Col xs={8} sm={6} md={6} className="right-col">
                  <Spin spinning={this.state.loading_account}>
                    <div className="avatar">
                      <Image preview={false} src={Number(this.state.account?.gender) === 2 ? AvatarWoman : AvatarMan}/>
                    </div>
                  </Spin>
                </Col>

              </Row>

              <Row align="center" className="store-row">

                <Col xs={20} md={18} lg={16} xl={8} className="store-col">
                  <p>Nejnavštěvovanější pobočka</p>
                  <Spin spinning={this.state.loading_center_data}>
                    {mostVisitedStore && <>
                      <strong>
                        {mostVisitedStore?.name}
                      </strong>

                      {mostVisitedStore.store_address &&

                        <>
                          <p className="store-address">
                            {mostVisitedStore.store_address?.address1 + ' ' + mostVisitedStore.store_address?.address2}
                          </p>

                          <p className="store-address">
                            {formatZIP(mostVisitedStore.store_address?.zip) + ', ' + mostVisitedStore.store_address?.city}
                          </p>
                        </>

                      }

                    </>}
                  </Spin>
                </Col>

                <Col xs={20} md={18} lg={16} xl={8} className="store-col">
                  <p>Místo registrace</p>
                  <Spin spinning={this.state.loading_account}>
                    {homeStore ? <>
                      <strong>{homeStore?.name}</strong>

                      {homeStore &&
                        <>
                          <p className="store-address">{homeStore.store_address?.address1 + ' ' + homeStore.store_address?.address2}</p>
                          <p className="store-address">{formatZIP(homeStore.store_address?.zip) + ', ' + homeStore.store_address?.city}</p>
                        </>
                      }

                    </>
                    :
                      <strong>-</strong>
                    }
                  </Spin>
                </Col>

                <Col xs={20} md={18} lg={16} xl={8} className="store-col">
                  <p>Poslední navštívená pobočka</p>
                  <Spin spinning={this.state.loading_center_data}>
                    {latestVisitedStore && <>
                      <strong>
                        {latestVisitedStore.name}
                      </strong>

                      {latestVisitedStore.store_address &&

                        <>
                          <p className="store-address">
                            {latestVisitedStore.store_address?.address1 + ' ' + latestVisitedStore.store_address?.address2}
                          </p>
                          <p className="store-address">
                            {formatZIP(latestVisitedStore.store_address?.zip) + ', ' + latestVisitedStore.store_address?.city}
                          </p>
                        </>

                      }

                    </>}
                  </Spin>
                </Col>

              </Row>

              <Row className="tile-row">

                <Col xs={12} md={6}>
                  <Link to="/profile-update">
                    <NavTileItem icon={ProfileSVG} title="Moje údaje"/>
                  </Link>
                </Col>

                <Col xs={12} md={6}>
                  <Link to="/reservations">
                    <NavTileItem icon={CollectionAppointmentSVG} title="Přehled rezervací"/>
                  </Link>
                </Col>

                <Col xs={12} md={6}>
                  <Link to="/compensations-history">
                    <NavTileItem icon={HealthConditionSVG} title="Přehled mých náhrad"/>
                  </Link>
                </Col>

                <Col xs={12} md={6}>

                  {this.state.is_allowed_to_show_registration_survey ?

                    <Link to="/survey">
                      <NavTileItem icon={MyOrdersSVG} title="Digitální dotazník"/>
                    </Link>

                    : (this.state.is_allowed_to_show_obnoveni_kvalifikace_survey) ?

                      <Link to="/survey-obnoveni-kvalifikace">
                        <NavTileItem icon={MyOrdersSVG} title="Digitální dotazník"/>
                      </Link>

                      :

                    <a href="#!" onClick={(e) => this.handleDigitalSurveyTaleClick(e)}>
                      <NavTileItem icon={MyOrdersSVG} title="Digitální dotazník"/>
                    </a>

                  }

                </Col>

                <Col xs={12} md={6}>
                  <Link to="/rewards-history">
                    <NavTileItem icon={AmberAccountSVG} title="Historie odměn"/>
                  </Link>
                </Col>

              </Row>
              <Row>
                <Col xs={24} md={24}>
                  {(window.hasOwnProperty("Cookiebot")) &&
                    <Button type="link" className="mt-2" onClick={() => window.Cookiebot.renew()}>Změnit nastavení cookies</Button>
                  }
                </Col>
              </Row>

            </Spin>
          </Col>
        </Row>
      </Layout>
    )
  }
}